import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import PainSection from './components/PainSection';
import AreasSection from './components/AreasSection';
import AboutSection from './components/AboutSection';
import HowItWorksSection from './components/HowItWorksSection';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="font-sans bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <PainSection />
        <AreasSection />
        <AboutSection />
        <HowItWorksSection />
        <CtaSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
